module.exports = __webpack_public_path__ + "static/media/done.829ecda6.svg";